import Box from '@mui/material/Box';
import { Button } from 'common/components/Buttons/Button';
import { useCallback, useState } from 'react';
import { RSimProductDetailsEditDialog } from './RSimProductDetailsEditDialog';

export const RSimDetailsEdit = ({ euicc }: { euicc: string }) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const handleOnClose = useCallback(() => {
    setEditDialogOpen(false);
  }, []);

  return (
    <Box flex={0} sx={{ display: 'flex', justifyContent: 'end' }}>
      <Button
        variant="secondary"
        onClick={() => {
          setEditDialogOpen(true);
        }}
      >
        Edit
      </Button>
      <RSimProductDetailsEditDialog euicc={euicc} open={editDialogOpen} onClose={handleOnClose} />
    </Box>
  );
};
